const CREATOR_SESSION_STORAGE_KEY = 'simpi-maker:dashboard-sso-token';

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage;
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(parts[1].length / 4) * 4, '=');
    return JSON.parse(window.atob(payload)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function isTokenExpired(token: string): boolean {
  const payload = decodeJwtPayload(token);
  const exp = Number(payload?.exp);
  if (!Number.isFinite(exp) || exp <= 0) return false;
  return exp <= Math.floor(Date.now() / 1000);
}

export function getStoredCreatorSessionToken(): string | null {
  const storage = getSessionStorage();
  const token = storage?.getItem(CREATOR_SESSION_STORAGE_KEY) || null;
  if (!token) return null;
  if (isTokenExpired(token)) {
    storage?.removeItem(CREATOR_SESSION_STORAGE_KEY);
    return null;
  }
  return token;
}

export function storeCreatorSessionToken(token: string): void {
  const storage = getSessionStorage();
  if (!storage) return;
  storage.setItem(CREATOR_SESSION_STORAGE_KEY, token);
}

export function clearCreatorSessionToken(): void {
  getSessionStorage()?.removeItem(CREATOR_SESSION_STORAGE_KEY);
}
